import { render } from "./InteractiveTable.vue?vue&type=template&id=5356e1e6&scoped=true"
import script from "./InteractiveTable.vue?vue&type=script&lang=js"
export * from "./InteractiveTable.vue?vue&type=script&lang=js"

import "./InteractiveTable.vue?vue&type=style&index=0&id=5356e1e6&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5356e1e6"]])

export default __exports__